import { DOWNLOAD_EMAIL_ASYNC } from '../AffMailboxesDetail/constants'
import { INCIDENT_REQUEST_ASYNC as ATO_REPORT_REQUEST_ASYNC } from '../AtoIncident/constants'
import { INCIDENT_TYPE } from '../constants'
import { REPORT_SELECT, URL_STATE_CHANGE } from '../List/constants'
import { EDIT_TAGS_REQUEST_ASYNC, TAGS_REQUEST_ASYNC } from '../TagsClassification/constants'

import {
  ACTION_STATE_CHANGE_TO_STATE,
  CLOSE_INCIDENT_ASYNC,
  CLOSE_SAFE_CHALLENGE_INCIDENT_ASYNC,
  DOWNLOAD_ORIGINAL_EMAIL_ASYNC,
  EMAIL_SNAPSHOT_ASYNC,
  EMAIL_TABS_KEYS,
  FETCH_AFFECTED_MAILBOXES_COUNTS_ASYNC,
  FETCH_ASSIGNEES_ASYNC,
  FETCH_COMMUNITY_INSIGHTS_ASYNC,
  FETCH_SCANS_FREEMIUM_LIMIT_ASYNC,
  KEEP_ENCRYPTED_INCIDENT_IN_QUARANTINE_ASYNC,
  RELEASE_ENCRYPTED_INCIDENT_ASYNC,
  REPORT_ELEMENTS_REQUEST_ASYNC,
  REPORT_ELEMENTS_UPDATE_ASYNC,
  REPORT_REQUEST_ASYNC,
  REPORT_STATE_CHANGE_ASYNC,
  SET_ESCALATED_EMAIL_CARD_TAB_KEY,
  SHOW_AFFECTED_MAILBOXES_VIEW,
  SHOW_SCANNER_DETAILS_VIEW,
  statusKeyMap,
} from './constants'

export default function () {
  const initialState = {
    data: {},
    snapshotUrl: null,
    emailSnapshotLoader: false,
    communityInsights: {},
    communityLoader: false,
    reportLoader: true,
    error: null,
    scannerDetails: null,
    affMailboxesDetails: null,
    affMailboxesDetailsForceEndUsers: false,
    affMailboxesCounts: {},
    scansFreemiumLimit: {},
    assignees: {
      loader: false,
      error: null,
      data: [],
    },
    downloadOriginalEmailLoader: false,
    isShowAccountTakeOverPopup: false,
    escalatedEmailCardTabKey: EMAIL_TABS_KEYS.EMAIL_BODY,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case REPORT_SELECT:
      case URL_STATE_CHANGE:
      case REPORT_STATE_CHANGE_ASYNC.INITIATE:
      case CLOSE_INCIDENT_ASYNC.INITIATE:
      case CLOSE_SAFE_CHALLENGE_INCIDENT_ASYNC.INITIATE:
      case RELEASE_ENCRYPTED_INCIDENT_ASYNC.INITIATE:
      case KEEP_ENCRYPTED_INCIDENT_IN_QUARANTINE_ASYNC.INITIATE:
        return {
          ...state,
          reportLoader: true,
          escalatedEmailCardTabKey: EMAIL_TABS_KEYS.EMAIL_BODY,
        }
      case REPORT_STATE_CHANGE_ASYNC.SUCCESS: {
        const replacer =
          action.payload.newState === 'delete' ||
          action.payload.reportType === INCIDENT_TYPE.POTENTIAL_MAIL ||
          action.payload.reportType === INCIDENT_TYPE.AUTO_THEMIS_POTENTIAL_MAIL
            ? { removed: true }
            : {
                state:
                  ACTION_STATE_CHANGE_TO_STATE[action.payload.reportType][action.payload.newState],
              }
        return {
          ...state,
          reportLoader: false,
          data: {
            ...state.data,
            ...replacer,
          },
          isShowAccountTakeOverPopup: action.payload.data.response.showAccountTakeOverPopup,
        }
      }
      case FETCH_AFFECTED_MAILBOXES_COUNTS_ASYNC.SUCCESS:
        return {
          ...state,
          affMailboxesCounts: action.payload.data,
        }
      case FETCH_SCANS_FREEMIUM_LIMIT_ASYNC.INITIATE:
        return { ...state, reportLoader: true }
      case FETCH_SCANS_FREEMIUM_LIMIT_ASYNC.SUCCESS:
        return {
          ...state,
          scansFreemiumLimit: action.payload.data,
        }
      case REPORT_REQUEST_ASYNC.INITIATE:
      case ATO_REPORT_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          scannerDetails: null,
          affMailboxesDetails: null,
        }
      case REPORT_REQUEST_ASYNC.SUCCESS: {
        const report = action.payload.data.report
        if (report.elements) {
          affectReportForElements(report, report.elements)
          delete report.elements
        }
        return {
          ...state,
          error: null,
          data: {
            ...report,
          },
          reportLoader: false,
        }
      }
      case REPORT_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          reportLoader: false,
        }
      case FETCH_ASSIGNEES_ASYNC.INITIATE: {
        return {
          ...state,
          assignees: { ...state.assignees, loader: true },
        }
      }
      case FETCH_ASSIGNEES_ASYNC.SUCCESS: {
        return {
          ...state,
          assignees: {
            loader: false,
            error: null,
            data: action.payload.data,
          },
        }
      }
      case FETCH_ASSIGNEES_ASYNC.ERROR:
        return {
          ...state,
          assignees: {
            loader: false,
            data: [],
            error: action.error.response?.message,
          },
        }
      case FETCH_COMMUNITY_INSIGHTS_ASYNC.INITIATE:
        return {
          ...state,
          communityLoader: true,
        }
      case FETCH_COMMUNITY_INSIGHTS_ASYNC.SUCCESS:
        return {
          ...state,
          communityLoader: false,
          communityInsights: action.payload.data,
        }
      case REPORT_STATE_CHANGE_ASYNC.ERROR:
      case FETCH_SCANS_FREEMIUM_LIMIT_ASYNC.ERROR:
      case CLOSE_INCIDENT_ASYNC.ERROR:
      case CLOSE_SAFE_CHALLENGE_INCIDENT_ASYNC.ERROR:
      case KEEP_ENCRYPTED_INCIDENT_IN_QUARANTINE_ASYNC.ERROR:
        return { ...state, error: action.error, reportLoader: false }
      case REPORT_STATE_CHANGE_ASYNC.CANCEL:
      case RELEASE_ENCRYPTED_INCIDENT_ASYNC.ERROR:
        return { ...state, reportLoader: false }
      case REPORT_ELEMENTS_UPDATE_ASYNC.INITIATE: {
        const { data } = state
        if (action.payload.elementsName === 'serversidescan') {
          data.scans?.map((elem) => (elem.status = 'Pending'))
        } else {
          data[action.payload.elementsName].map((elem) => (elem.status = statusKeyMap.scanning))
        }
        return {
          ...state,
          data,
        }
      }
      case REPORT_ELEMENTS_REQUEST_ASYNC.SUCCESS: {
        const { data } = state
        // check if user didn't change report till updating cb is triggered.
        if (data.id === action.payload.reportId) {
          affectReportForElements(data, action.payload.data.elements, action.payload.elementsName)
          return {
            ...state,
            data: { ...data },
          }
        }
        return state
      }
      case TAGS_REQUEST_ASYNC.SUCCESS: {
        if (
          action.payload.reportId &&
          action.payload.reportType &&
          (action.payload.reportType === INCIDENT_TYPE.MAIL ||
            action.payload.reportType === INCIDENT_TYPE.TEAMS) &&
          action.payload.reportId === state.data.id
          // Here also need the check below, because different
          // report types might have the same id.
          // action.payload.reportType === state.data.reportType
          // But because there is no reportType inside report
          // reducer no way to check.
          // Two options how to resolve:
          // 1) think about storing it here
          // 2) return from BE
          // For now I consider it as an edge case.
        ) {
          return {
            ...state,
            data: {
              ...state.data,
              tags: action.payload.data.selectedTags,
            },
          }
        } else return state
      }
      case EDIT_TAGS_REQUEST_ASYNC.SUCCESS:
        if (action.payload.reportId === state.data.id) {
          return {
            ...state,
            data: {
              ...state.data,
              tags: action.payload.data,
            },
          }
        } else return state
      case SHOW_SCANNER_DETAILS_VIEW:
        return { ...state, scannerDetails: action.payload.data }
      case SHOW_AFFECTED_MAILBOXES_VIEW:
        return { ...state, affMailboxesDetails: action.payload.data }

      case DOWNLOAD_ORIGINAL_EMAIL_ASYNC.INITIATE:
        return { ...state, downloadOriginalEmailLoader: true }
      case DOWNLOAD_ORIGINAL_EMAIL_ASYNC.SUCCESS:
      case DOWNLOAD_ORIGINAL_EMAIL_ASYNC.ERROR:
        return { ...state, downloadOriginalEmailLoader: false }
      case EMAIL_SNAPSHOT_ASYNC.INITIATE: {
        return {
          ...state,
          emailSnapshotLoader: true,
        }
      }
      case EMAIL_SNAPSHOT_ASYNC.SUCCESS: {
        return {
          ...state,
          snapshotUrl: action.payload,
          emailSnapshotLoader: false,
        }
      }
      case EMAIL_SNAPSHOT_ASYNC.ERROR: {
        return {
          ...state,
          snapshotUrl: null,
          emailSnapshotLoader: false,
        }
      }
      case SET_ESCALATED_EMAIL_CARD_TAB_KEY: {
        return {
          ...state,
          escalatedEmailCardTabKey: action.payload.key,
        }
      }
      // case DOWNLOAD_EMAIL_ASYNC.ERROR: {
      //   const foundMailbox = state.data.affectedMailboxes.find(
      //     (mailbox) => mailbox.id === action.payload.id
      //   )
      //   if (foundMailbox) {
      //     foundMailbox.disabled = true
      //   }
      //   return {
      //     ...state,
      //     data: {
      //       ...state.data,
      //       affectedMailboxes: [...state.data.affectedMailboxes],
      //     },
      //   }
      // }
      default:
        return state
    }
  }
}

const affectReportForElements = (report, elements, elementsName) => {
  if (!elementsName || elementsName === 'attachments') {
    report.attachments = elements.filter((e) => e.otype === 1).map((e) => ({ ...e }))
  }
  if (!elementsName || elementsName === 'links') {
    report.links = elements.filter((e) => e.otype === 2).map((e) => ({ ...e }))
  }
  if (elementsName === 'serversidescan') {
    report.scans = elements
  }
}
